export const accessibilityLimitationsKeys = [
  "accessibilityAssessment",
  "limitations",
];
